export const APPROVED = 'approved';
export const REJECTED = 'rejected';
export const PENDING_NEW = 'pending_new';
export const PENDING_UPDATE = 'pending_update';
export const NONE = 'none';
